// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ApplicationController {
   $authEvents: any
   $broadcastTypes: any
   $location: angular.ILocationService
   $log: angular.ILogService
   $q: angular.IQService
   $route: any
   $routeParams: any
   $scope: any
   $timeout: any
   $uibModal: any
   $window: any
   advancedSearch: AdvancedSearchService
   alertService: AlertService
   appState: AppStateService
   authenticationService: AuthenticationService
   cloudStorage: CloudStorageService
   config: ConfigService
   dialogService: DialogService
   docDetail: any
   events: any
   externalPlugins: any
   facets: any
   flowService: any
   journalTitleService: JournalTitleService
   loadNextQuickLook: any
   localizationService: LocalizationService
   mediaQueryService: MediaQueryService
   menuManager: any
   metrics: any
   savedSearch: any
   savedItems: any
   searchScopeService: SearchScopeService
   sierraService: SierraService
   translationService: TranslationService
   urlRewriter: UrlRewriter
   urlService: UrlService
   utilities: any
   viewStateService: ViewStateService
   $document: any
   searchService: SearchService

   
   constructor($scope: any, appState: AppStateService, docDetail: any, $route: any, $routeParams: any, $location: any, config: any, utilities: any, 
      metrics: any, events: any, facets: any, flowService: any, advancedSearch: AdvancedSearchService, $timeout: any, dialogService: DialogService, $q: any,
      urlRewriter: UrlRewriter, localizationService: LocalizationService, $window: any, $broadcastTypes: any, alertService: any, viewStateService: ViewStateService, 
      $filter: any, menuManager: any, translationService: TranslationService, citationValues: any, externalPlugins: any, journalTitleService: JournalTitleService, 
      savedSearch: any, savedItems: any, cloudStorage: any, authenticationService: AuthenticationService, sierraService: SierraService, mediaQueryService: MediaQueryService, 
      $authEvents: any, $log: any, $uibModal: any, searchScopeService: SearchScopeService, $document: any, urlService: UrlService, researchAssistantService: ResearchAssistantService,
      searchService: SearchService) {

      this.setWindowTitle = this.setWindowTitle.bind(this)
      this.setRetainState = this.setRetainState.bind(this)
      this.initFlow = this.initFlow.bind(this)
      this.itemSaveCompletionFlow = this.itemSaveCompletionFlow.bind(this)
      this.initSavedSearch = this.initSavedSearch.bind(this)
      this.initSavedItems = this.initSavedItems.bind(this)
      this.initLoadingIndicators = this.initLoadingIndicators.bind(this)
      this.handleApiEvents = this.handleApiEvents.bind(this)
      this.handleApiError = this.handleApiError.bind(this)
      this.rollback = this.rollback.bind(this)
      this.excludeHoldingsOnly = this.excludeHoldingsOnly.bind(this)
      this.issueNewSearch = this.issueNewSearch.bind(this)
      this.searchAll = this.searchAll.bind(this)
      this.clearRefinements = this.clearRefinements.bind(this)
      this.getIncludeFTParamOnClear = this.getIncludeFTParamOnClear.bind(this)
      this.unroll = this.unroll.bind(this)
      this.fieldSearch = this.fieldSearch.bind(this)
      this.multipleFieldSearch = this.multipleFieldSearch.bind(this)
      this.expandQueryWithSubjectTermsCombined = this.expandQueryWithSubjectTermsCombined.bind(this)
      this.setNewSearchState = this.setNewSearchState.bind(this)
      this.newSearch = this.newSearch.bind(this)
      this.disableEnhancedDidYouMean = this.disableEnhancedDidYouMean.bind(this)
      this.querySuggestion = this.querySuggestion.bind(this)
      this.clearJournalTitle = this.clearJournalTitle.bind(this)
      this.openJournalTitle = this.openJournalTitle.bind(this)
      this.openDetailPage = this.openDetailPage.bind(this)
      this.toggleQuickLook = this.toggleQuickLook.bind(this)
      this.toggleJournalCoverageDetails = this.toggleJournalCoverageDetails.bind(this)
      this.openClickTrackLink = this.openClickTrackLink.bind(this)
      this.disableQueryExpansion = this.disableQueryExpansion.bind(this)
      this.sortResults = this.sortResults.bind(this)
      this.resetNewSearchFlag = this.resetNewSearchFlag.bind(this)
      this.displayDialog = this.displayDialog.bind(this)
      this.routeRequest = this.routeRequest.bind(this)
      this.showLibraryCard = this.showLibraryCard.bind(this)
      this.switchTab = this.switchTab.bind(this)
      this.applyFTMatchesAndDisableBeyondHolding = this.applyFTMatchesAndDisableBeyondHolding.bind(this)
      this.applyIsIncludeFtMatchesNoResults = this.applyIsIncludeFtMatchesNoResults.bind(this)
      this.isbulkExportAllowed = this.isbulkExportAllowed.bind(this)
      this.showSearchPagination = this.showSearchPagination.bind(this)
      this.homePageNavigationEnabled = this.homePageNavigationEnabled.bind(this)


      this.$scope = $scope
      this.appState = appState
      this.docDetail = docDetail
      this.$route = $route
      this.$routeParams = $routeParams
      this.$location = $location
      this.config = config
      this.utilities = utilities
      this.metrics = metrics
      this.events = events
      this.facets = facets
      this.flowService = flowService
      this.advancedSearch = advancedSearch
      this.$timeout = $timeout
      this.dialogService = dialogService
      this.$q = $q
      this.urlRewriter = urlRewriter
      this.localizationService = localizationService
      this.$window = $window
      this.$document = $document
      this.$broadcastTypes = $broadcastTypes
      this.alertService = alertService
      this.viewStateService = viewStateService
      this.menuManager = menuManager
      this.translationService = translationService
      this.externalPlugins = externalPlugins
      this.journalTitleService = journalTitleService
      this.savedSearch = savedSearch
      this.savedItems = savedItems
      this.cloudStorage = cloudStorage
      this.authenticationService = authenticationService
      this.sierraService = sierraService
      this.mediaQueryService = mediaQueryService
      this.searchScopeService = searchScopeService
      this.$authEvents = $authEvents
      this.$log = $log
      this.$uibModal = $uibModal
      this.urlService = urlService
      this.searchService = searchService

      this.$scope.excludeHoldingsOnly = this.excludeHoldingsOnly
      this.$scope.applyFTMatchesAndDisableBeyondHolding = this.applyFTMatchesAndDisableBeyondHolding
      this.$scope.applyIsIncludeFtMatchesNoResults = this.applyIsIncludeFtMatchesNoResults
      this.$scope.clearRefinements = this.clearRefinements
      this.$scope.unroll = this.unroll
      this.$scope.fieldSearch = this.fieldSearch
      this.$scope.multipleFieldSearch = this.multipleFieldSearch
      this.$scope.newSearch = this.newSearch
      this.$scope.disableEnhancedDidYouMean = this.disableEnhancedDidYouMean
      this.$scope.querySuggestion = this.querySuggestion
      this.$scope.clearJournalTitle = this.clearJournalTitle
      this.$scope.openJournalTitle = this.openJournalTitle
      this.$scope.openDetailPage = this.openDetailPage
      this.$scope.toggleQuickLook = this.toggleQuickLook
      this.$scope.toggleJournalCoverageDetails = this.toggleJournalCoverageDetails
      this.$scope.loadNextQuickLook = this.loadNextQuickLook
      this.$scope.openClickTrackLink = this.openClickTrackLink
      this.$scope.setWindowTitle = this.setWindowTitle
      this.$scope.setRetainState = this.setRetainState
      this.$scope.disableQueryExpansion = this.disableQueryExpansion
      this.$scope.sortResults = this.sortResults
      this.$scope.showLibraryCard = this.showLibraryCard
      this.$scope.switchTab = this.switchTab
      this.$scope.isbulkExportAllowed = this.isbulkExportAllowed
      this.$scope.showSearchPagination = this.showSearchPagination
        this.$scope.homePageNavigationEnabled = this.homePageNavigationEnabled

      this.$scope.displayLibraryCardMenu = this.config.data.libraryCard.displayLibraryCard
      this.$scope.authenticationService = this.authenticationService
      this.$scope.loggedIn = this.authenticationService.scope.loggedInStatusForBanner
      this.$scope.loggedInUser = this.authenticationService.scope.usernameForBanner
      this.$scope.retainState = false
      this.$scope.okToRollback = false
      this.$scope.error = {}
      this.$scope.currentScreenSize = this.mediaQueryService.current.size
      this.$scope.displayDialog = this.displayDialog.bind(this)
      this.$scope.textDirection = this.localizationService.localization.dir
      this.$scope.docDetail = this.docDetail
      this.$scope.viewState = this.viewStateService
      this.$scope.appState = this.appState
      this.$scope.i18n = this.translationService
      this.$scope.citationValues = citationValues
      this.$scope.issueNewSearch = this.issueNewSearch
      this.$scope.searchAll = this.searchAll
      this.$scope.resetNewSearchFlag = this.resetNewSearchFlag
      this.$scope.newSearchInfo = {isNewSearch: false, firstLoad: true}

      this.$scope.closeAllMenuTypeSubMenu = this.menuManager.closeAllMenuTypeSubMenu
      this.$scope.closeAllMenuTypeMenu = this.menuManager.closeAllMenuTypeMenu
      this.$scope.menu = this.menuManager.menu
      this.$scope.subMenu = this.menuManager.subMenu
      this.$scope.areAllMenuTypeMenuClosed = this.menuManager.areAllMenuTypeMenuClosed
      this.$scope.areAllMenuTypeSubMenuClosed = this.menuManager.areAllMenuTypeSubMenuClosed
      this.$scope.isResearchAssistantEnabled = researchAssistantService.isResearchAssistantEnabled
      this.$scope.clickTrackLinkForm = {
         action: '/2.0.0/link', // default to API link endpoint
         linkData: ''
      }

      // set various configurations
      this.$scope.advancedEnabled = this.config.data.advancedSearch.enabled
      this.$scope.savedSearchEnabled = this.config.data.savedSearchAndItems.searchEnabled
      this.$scope.displayAZSearchBlock = this.config.data.widgets.enableAZSearchWidget
      this.$scope.displaySecondarySearch = (this.config.data.widgets.secondaryClient != null)
      this.$scope.isPreviewEnv = (this.config.data.env.value === 'preview')
      this.$scope.showPreviewBanner = true
      this.$scope.closePreviewBanner = () => { return this.$scope.showPreviewBanner = false }
      this.$scope.nonExactResultCount = this.config.data.search.nonExactResultCount
      this.$scope.allowDownloadSearchResults = this.config.data.bulkExport?.enabled || false

      // VPN banner configuration
      this.$scope.vpnBanner = {
         href: () => {
            const vpnConfig = this.config.data.vpnBanner
            const currentUrl = this.$location.absUrl()
            const isSummonUrl = true
            if (vpnConfig.bannerUrl) { return vpnConfig.bannerUrl } else { return this.utilities.proxify(currentUrl, vpnConfig.proxy, isSummonUrl) }
         },
         text: this.translationService.translate(this.config.data.vpnBanner.text),
         authenticated: this.config.data.vpnBanner.authenticated || this.authenticationService.isLoggedIntoSummonApi(),
         enabled: this.config.data.vpnBanner.enabled,
         useSamlAuth: this.authenticationService.scope.useSamlForSearchApiAuth,
         loginWithSaml: this.authenticationService.loginToSummonWithSaml
      }
      // RSS-related functions
      this.$scope.rssLink = () => "/rss?" + $.param(this.$routeParams)
      this.$scope.enableRssLink = () => {
         const query = this.$routeParams["q"]
         return this.config.data.results.showRss && (query !== "*") && (query !== "")
      }

      // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
      this.setWindowTitle()
      this.initLoadingIndicators()
      this.initFlow() // fetch Flow profile at load
      this.initSavedSearch()
      this.initSavedItems()
    
      this.$scope.$on('uib:modal.opening', (event: any, modal: any) => // when the dialog opens it sets overflow:hidden, so the scrollbar disappears, 
      // but that shifts the layout a bit. This can be compensated by setting margin to scrollbar-size
      // this makes sure the scrollbar width is checked before opening the modal, so if there is no scrollbar, it doesn't use the wrong value
         document.documentElement.style.setProperty(
            '--scrollbar-width',
            (window.innerWidth - document.documentElement.offsetWidth) + 'px'
         ))

      // set watch on changes made to $route
      this.$scope.$on('$routeChangeSuccess', this.routeRequest)

      this.$scope.$watch("authenticationService.scope.loggedInStatusForBanner", (newVal: any, oldVal: any) => {
         return this.$scope.loggedIn = newVal
      })

      this.$scope.$watch("authenticationService.scope.usernameForBanner", (newVal: any, oldVal: any) => {
         return this.$scope.loggedInUser = newVal
      })

      if(this.authenticationService.scope.useSamlForSearchApiAuth && !this.config.data.vpnBanner.authenticated){
         this.$scope.$watch("authenticationService.scope.auth.saml.loggedIn", (newVal: any, oldVal: any) => {
            return this.$scope.vpnBanner.authenticated = this.authenticationService.isLoggedIntoSummonApi()
         })
      }

      if(this.config.data.authentication.ltiConfigurationExists && !this.config.data.vpnBanner.authenticated){
         this.$scope.$watch("authenticationService.scope.auth.lti.loggedIn", (newVal: any, oldVal: any) => {
            return this.$scope.vpnBanner.authenticated = this.authenticationService.isLoggedIntoSummonApi()
         })
      }

      // clean up
      this.$scope.$on('$destroy', () => {
         this.savedSearch.off('getSearches', this.$scope.$id)
         this.savedItems.off('getSavedItems', this.$scope.$id)
         this.flowService.off('itemSaveCompletion', this.itemSaveCompletionFlow)
      })

      // backwards url compatibility
      this.urlRewriter.rewrite()
   }



   setWindowTitle(title: any) {
      title = title ? title + " - " : ""
      return this.$scope.windowTitle = (document.title = this.utilities.removeHithighlightTags(title + this.config.data.head.title))
   }

   setRetainState(val: any) {
      return this.$scope.retainState = val
   }

   initFlow() {
      // handle flow errors
      this.flowService.on('itemSaveCompletion', this.itemSaveCompletionFlow)
      if (this.flowService.configs.enabled) { return this.flowService.getProfile() }
   }

   itemSaveCompletionFlow(msg: any) {
      const errorMessage = msg.errorMessage || ""
      if (!errorMessage) { return }
      if (errorMessage.indexOf('access_token_invalid') > -1) {
      // reset the Flow login link
         this.flowService.getProfile()
         this.$scope.error.message = this.$scope.i18n.translations.SAVE_FLOW_ERROR_AUTH
      } else {
         this.$scope.error.message = this.$scope.i18n.translations.SAVE_FLOW_ERROR
      }
      // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
      return this.displayDialog("error")
   }

   initSavedSearch() {
      // set up hook on getSearches event
      return this.savedSearch.on('getSearches', this.$scope.$id, (data: any) => {
      // handle errors
         if (data instanceof Error) {
            return this.alertService.setAlert('savedSearchError', data.message)
         }
      })
   }

   initSavedItems() {
      // set up hook on getSavedItems event
      return this.savedItems.on('getSavedItems', this.$scope.$id, (data: any) => {
      // handle errors
         if (data instanceof Error) {
            return this.alertService.setAlert('savedItemsError', data.message)
         }
      })
   }

   initLoadingIndicators() {
      // turn on loading indicators when an API request is made
      this.$scope.$on('apiRequest', (evt: any, msg: any) => {
         if (msg.types.includes(this.$broadcastTypes.newSearch) || (this.$scope.viewState.currentView !== 'search')) {
            return this.$scope.loadingNewSearchIndicator = true
         } else if (msg.types.includes(this.$broadcastTypes.search) && !this.$scope.feed.loading && !this.$scope.loadingNewSearchIndicator) {
            return this.$scope.loadingSearchIndicator = true
         } else if (msg.types.includes(this.$broadcastTypes.moreFacets)) {
            return this.$scope.loadingFacetIndicator = true
         }
      })

      // turn off loading indicators when an API response (success/cancel/failure) is received
      this.$scope.$on('apiSuccess', this.handleApiEvents)
      this.$scope.$on('apiCancel', this.handleApiEvents)
      return this.$scope.$on('apiError', this.handleApiError)
   }

   handleApiEvents(evt: any, msg: any) {
      // set okToRollback flag upon first successful search processed
      if (!this.$scope.okToRollback && (evt.name === 'apiSuccess')) { this.$scope.okToRollback = true }
      const requestCanceled = evt.name === 'apiCancel'
      if (msg.types.includes(this.$broadcastTypes.newSearch)) {
      // display new search indicator until a non-canceled request has been processed
         if (!requestCanceled) { this.$scope.loadingNewSearchIndicator = false }
      }
      if (msg.types.includes(this.$broadcastTypes.search)) {
      // display search indicator until a new search has been initiated or a non-canceled request has been processed
         if (!requestCanceled || !!this.$scope.loadingNewSearchIndicator) { this.$scope.loadingSearchIndicator = false }
         // turn off infinite scroll loading indicator and turn on search loading
         // indicator if scroll request was canceled
         if (this.$scope.feed.loading) {
            this.$scope.feed.loading = false
            // don't show the search indicator if a new search canceled the page request
            if (requestCanceled && !this.$scope.loadingNewSearchIndicator) { this.$scope.loadingSearchIndicator = true }
         }
      }
      if (msg.types.includes(this.$broadcastTypes.moreFacets)) {
         this.$scope.loadingFacetIndicator = false
      }

      // handle external events
      if (_.intersection(msg.types, [this.$broadcastTypes.search, this.$broadcastTypes.newSearch]).length) {
      // fire external plugin events when search results come back and are rendered
         return this.externalPlugins.fire({name:'searchResults'}, msg)
      }
   }

   handleApiError(evt: any, msg: any) {
      const {
         errorObject
      } = msg
      this.handleApiEvents(evt, msg)
      if (_.intersection([this.$broadcastTypes.newSearch, this.$broadcastTypes.search], msg.types).length) {
      // set error message to API error message, else set to default message based off of http status and broadcast type
         this.$scope.error.message = errorObject.errors?.[0].message ||
        (() => { switch (errorObject.httpStatus) {
           case 429:
              return this.$scope.i18n.translations.APP_ERROR_MSG_429
           case 400:
              return this.$scope.i18n.translations.APP_ERROR_MSG_400
           default:
              if (this.$scope.isPreviewEnv) { return this.$scope.i18n.translations.PREVIEW_ENV_ERROR_MSG } else { return this.$scope.i18n.translations.APP_ERROR_MSG }
        } })()
      }

      // only display error messages when appropriate
      if (!msg.types.includes(this.$broadcastTypes.other)) {
         if (msg.isPageRequest && (errorObject.httpStatus !== 400) && !msg.types.includes(this.$broadcastTypes.citationTrail)) {
            this.alertService.setAlert('pageRequestError', 'Results failed to load.')
         } else if (msg.types.includes(this.$broadcastTypes.citationTrail)) {
            this.alertService.setAlert('citationTrailError', 'Citations failed to load.')
         } else if (msg.types.includes(this.$broadcastTypes.moreFacets)) {
            this.alertService.setAlert('facetError', 'More facets failed to load.' )
         } else if (msg.types.includes(this.$broadcastTypes.contentTypes)) {
            this.alertService.setAlert('contentTypesError', 'Content types failed to load.')
         } else if (msg.types.includes(this.$broadcastTypes.disciplines)) {
            this.alertService.setAlert('disciplinesError', 'Disciplines failed to load.')
         } else if (msg.types.includes(this.$broadcastTypes.languages)) {
            this.alertService.setAlert('languagesError', 'Languages failed to load.')
         } else {
            // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
            this.displayDialog(this.$scope.isPreviewEnv ? "previewError" : "error")
         }
      }

      // go back to previous search state if error occurs; give time for error message to display
      if (!msg.isPageRequest && !_.intersection([this.$broadcastTypes.moreFacets, this.$broadcastTypes.citationTrail, this.$broadcastTypes.other], msg.types).length) {
         return this.$timeout((() => this.rollback()), 400)
      }
   }

   rollback() {
      if (this.$scope.okToRollback && _.keys(this.appState.paramsSnapShot).length) {
         return this.appState.rollbackState()
      }
   }

   excludeHoldingsOnly() {
      const setState = () => {
         this.appState.params.ho = false
      }
      this.appState.applyStateWithSnapShot(setState)
      this.events.gaPush('refinements', 'add' , 'expand results')
   }

   applyIsIncludeFtMatchesNoResults(){
      const setState = () => {
         this.appState.params['include.ft.matches'] = true
      }
      this.appState.applyStateWithSnapShot(setState)
   }

   applyFTMatchesAndDisableBeyondHolding(){
      const setState = () => {
         this.appState.params.ho = false
         this.appState.params['include.ft.matches'] = true
      }
      this.appState.applyStateWithSnapShot(setState)
      this.events.gaPush('refinements', 'add' , 'expand results')
   }

   issueNewSearch() {
      //Turns on the flag below to hide the previous search pane and
      //show the appropriate message. It also deletes the search term
      //The flag is set to false again in SearchBoxController.newSearch() to restore the panes
      this.$scope.newSearchInfo.isNewSearch = true
      this.journalTitleService.clearJournalTitle()
      this.advancedSearch.clear()

      // Clear the jt param here instead of within clearRefinements since
      // we can set/clear refinements within a journal title search. Don't
      // want to clear out the jt param when searching within a journal title.
      // issueNewSearch should also remove previous query from URL fragment
      this.appState.resetParams()
      this.appState.applyStateWithSnapShot()
   }

   searchAll(){
      const setState = () => {
         const {
            params
         } = this.appState
         params.searchscope=''
         this.searchScopeService.setDefaultScope()
      }
      this.appState.applyStateWithSnapShot(setState)
   }

   clearRefinements() {
      const setState = () => {
         const {
            params
         } = this.appState
         params.fvf = []
         params.pn = 1
         params.fvfi = []
         params.myinst = ''
         params.ho = true
         params.rf = []
         params['include.ft.matches'] = this.getIncludeFTParamOnClear(this.config.data.quickFilters)
         params.searchscope=''
         delete params.oaf
         delete params['print.books.only']
         delete params['ebooks.only']

      }
      this.appState.applyStateWithSnapShot(setState)
      return this.events.gaPush('refinements', 'clear', 'all')
   }



   getIncludeFTParamOnClear(quickFilters: any){
      let param = ''
      _(quickFilters?.filters).map((f: any) => {
         if (f.facet === 'include.ft.matches') {
            if (f.defaultInclusion) {
               return param = 't'
            } else {
               return param = 'f'
            }
         }
      })
      return param
   }


   unroll(filters: any) {
      const setState = () => {
         const facet = {name: 'ContentType'}
         return filters.forEach((filter: any) => {
            return this.facets.add(facet, filter)
         })
      }
      this.appState.applyStateWithSnapShot(setState)
   }

   fieldSearch(field: any, value: any, separator = false) {
      if (this.$scope.view !== 'search' || this.$scope.viewState.currentView === 'research_assistant') { this.$location.path('/search') }
      this.$scope.viewState.currentView = 'search'
      this.$scope.closeAllMenuTypeSubMenu()
      const values = separator ? value.split(separator).map((v: any) => v.trim()) : [value]
      let q = values.map((v: any) => `${field}:\"${v}\"`).join(' AND ')
    
      // CDI-20825: Expand query in case user clicked on a 'subject' link from quick look to match labels from physical record. 
      if (field === 'SubjectTerms') {      
         q = this.expandQueryWithSubjectTermsCombined(q, value)
      }

      const setState = () => {
         this.appState.params.q = q
         return delete this.appState.params.bookMark
      }
      this.appState.applyStateWithSnapShot(setState)
      return this.events.gaPush('search', 'field', this.appState.params.q)
   }

   multipleFieldSearch(field: any, value: any, separator = false) {
      if (this.$scope.view !== 'search') { this.$location.path('/search') }
      this.$scope.viewState.currentView = 'search'
      this.$scope.closeAllMenuTypeSubMenu()
      const fields = separator ? field.split(separator).map((v: any) => v.trim()) : [field]
      const values = separator ? value.split(separator).map((v: any) => v.trim()) : [value]
      const q = values.map((v: any, i: any) => `${fields[i]}:\"${v}\"`).join(' AND ')
      const setState = () => {
         this.appState.params.q = q
         return delete this.appState.params.bookMark
      }
      this.appState.applyStateWithSnapShot(setState)
      return this.events.gaPush('search', 'field', this.appState.params.q)
   }

   expandQueryWithSubjectTermsCombined(query: any, value: any) { 
      //Expected result: q=(SubjectTerms:"Peanuts" AND SubjectTerms:"Fiction.") OR (SubjectTermsCombined:"Peanuts – Fiction.")
      const subjectTermsCombinedQuery = 'SubjectTermsCombined:\"' + value + '\"'
      const newQuery = [query, subjectTermsCombinedQuery]
      return newQuery.map(q => '(' + q + ')').join(' OR ')
   }

   setNewSearchState(query: any) {
      const setState = () => {
         const {
            params
         } = this.appState
         params.q = query
         return delete params.sort
      }
      this.appState.applyStateWithSnapShot(setState)
   }

   newSearch(query: any) {
      this.setNewSearchState(query)
      return this.events.gaPush('search', 'new', query)
   }

   disableEnhancedDidYouMean() {
      const setState = () => {
         return this.appState.params.edym = "f"
      }
      this.appState.applyStateWithSnapShot(setState)
   }

   querySuggestion(query: any) {
      const originalQuery = this.appState.params.q
      this.setNewSearchState(query)
      this.events.publish("actions", "query_suggestion:query", {
         originalQuery,
         query
      }
      )
      return this.events.gaPush('search', 'linked', query)
   }

   openJournalTitle(journalTitle: String){
      const newParams = _.clone(this.appState.params)
      newParams.jt = this.utilities.removeHithighlightTags(this.utilities.summonEscape(journalTitle))
      newParams.q = ''
      delete newParams.sort
      const newQuery = this.urlService.urlParamsStringFor(newParams)
      return '/#!/search?' + newQuery
   }

   clearJournalTitle() {      
      this.appState.params.jt = ''
      return this.appState.applyState()
   }

   openDetailPage(doc: any) {
      this.$scope.viewState.currentView = "detailsPage"
      this.setWindowTitle(doc.title)
      if (doc?.wos || doc?.wos_cited_record_id) {
         this.events.trackUsage('wos')
      }
      return this.$scope.docDetail.setDocument(doc)
   }

   toggleQuickLook(doc: any) {
      // setting viewstate to quicklook, so events handling scroll on search are not executed
      this.$scope.document = doc
      if (doc?.wos || doc?.wos_cited_record_id) {
         this.events.trackUsage('wos')
      }
      return this.dialogService.displayModalDialog(this.$scope, 'QuickLookCtrl','quick-look', 'quickLook/quickLook.html')
   }

   toggleJournalCoverageDetails(doc: any, isAlmaClient: any, animation = true) {
      this.$scope.document = doc
      this.$scope.isAlmaClient = isAlmaClient
      return this.dialogService.displayModalDialog(this.$scope, 'journalCoverageDetailsController','journal-coverage-details', 'journalCoverageDetails.html')
   }

   openClickTrackLink(link: any, doc: any) {
      if (doc?.wos || doc?.wos_cited_record_id) {
         this.events.trackUsage('wos')
      }
      const formData = this.$scope.clickTrackLinkForm
      // parse the record's link and set form values
      const delimiter = (() => { switch (false) {
         case !link.match(/link\/dbrecommender\//): return 'link/dbrecommender/'
         case !link.match(/link\/topicrec\//): return 'link/topicrec/'
         default: return 'link/'
      } })()

      const [formAction, linkData] = link.split(delimiter)
      // t param w/date value is added to prevent iOS from caching POST response - SUM-90697
      formData.action = formAction + delimiter.slice(0, -1) + '?t=' + Date.now()
      return formData.linkData = linkData
   }

   disableQueryExpansion() {
      const setState = () => {
         return this.appState.params.exp = false
      }
      this.appState.applyStateWithSnapShot(setState)
   }

   sortResults(field: any, order: any) {
      const setState = () => {
         const {
            params
         } = this.appState
         params.pn = 1
         if (!field || !order) {
            delete params.sort
            return this.events.gaPush('sort', 'results', 'Relevance')
         } else {
            params.sort = `${field}:${order}`
            return this.events.gaPush('sort', 'results', params.sort)
         }
      }
      this.appState.applyStateWithSnapShot(setState)
   }

   resetNewSearchFlag() {
      return this.$scope.newSearchInfo.isNewSearch = false
   }

   displayDialog(type: any, event: any) {
      const currentTarget = typeof event === 'string' ?
         angular.element(event)
         : event ?
            event.currentTarget
            :
            null
      return this.dialogService.displayDialog(type, this.$scope, () => this.events.publish("actions", `dialog:${type}`))
         .then(() => {  if (currentTarget != null) { return currentTarget.focus() } })
   }

   routeRequest(event: any, currentRoute: any, previousRoute: any) {
      // don't perform routing until url contains hashbang
      let needle
      if (!this.urlRewriter.urlHasHashBang()) { return }
      
      const currentPath = this.$location.path()
      const hasRouteParams = _.keys(this.$routeParams).length
      if (previousRoute?.action === 'advanced') { // handle legacy deep links to 'advancedSearch'
         const isScopeBuilderInit = currentPath === '/scope_builder/search'
         this.$scope.search.toggleAdvanced(isScopeBuilderInit)
      }

      if(this.$scope.newSearchInfo.firstLoad) {
         this.$scope.newSearchInfo.firstLoad = false
         if(this.$routeParams.pn) {
            this.$routeParams.pn = '1'
         }
      }

      switch (true) {
         case '/' === currentPath:
            if (hasRouteParams) {
               this.$scope.view = 'search'
               this.$scope.viewState.currentView = "search"
               // replace() changes the current URL w/out creating a new history record; used for redirecting
               return this.$location.path('/search').replace()
            } else {
               this.setWindowTitle(this.$scope.i18n.translations.HOME)
               if (this.$scope.savedSearch && this.$scope.savedSearch.visible) { this.$scope.savedSearch.visible = false }
               this.$scope.view = 'home'
               return this.$scope.viewState.currentView = "home"
            }
         case '/widgets' === currentPath:
            this.setWindowTitle(this.$scope.i18n.translations.WIDGET_BUILDER)
            this.$scope.view = 'widgets'
            return this.setRetainState(false)
         case /^\/course_reserves(\/{1}.+)?$/.test(currentPath):
            this.setWindowTitle(this.$scope.i18n.translations.COURSE_RESERVES)
            this.$scope.view = 'course_reserves'
            this.setRetainState(false)
            return this.$scope.courseReservesHasRendered = true
         case '/search' === currentPath:
            // when navigating from home to library search, if there are no route params or existing search query, run an empty search 
            this.$scope.view = 'search'
            if (!hasRouteParams) {
               this.setRetainState(true)
               this.searchService.runSearch(this.$scope.search, this.$scope.view)
            }      
            if (this.$scope.viewState.currentView === "home" || this.$scope.viewState.currentView === "research_assistant")
               this.$scope.viewState.currentView = "search"
            // handle the use of back/forward buttons
            if (this.$scope.advancedEnabled && this.$scope.search.advanced) {
               this.setRetainState(true)
               this.$scope.search.advanced = false
            }

            if (this.$scope.docDetail) {
            // handle the use of back/forward buttons
               if (this.$scope.docDetail.visible) {
                  this.$scope.viewState.currentView = 'search'
                  this.$scope.docDetail.visible = false
               }

               // clear the document if it exists
               if (this.docDetail.scope.doc.id) {
                  if (this.$scope.viewState.currentView !== "search") {
                     this.$scope.viewState.currentView = "search"
                  }
                  this.setRetainState(true)
                  this.docDetail.clearDocument()
                  return
               }
            }

            if (this.$scope.saveditems?.visible) { this.$scope.saveditems.visible = false }
            if (this.$scope.savedSearch?.visible) { this.$scope.savedSearch.visible = false }
            if (hasRouteParams && !this.$scope.retainState) { this.appState.applyStateFromUrlParams(this.$routeParams) } 
            this.setWindowTitle(this.$scope.i18n.translations.RESULTS_FOR + `\"${this.$scope.search.query}\"`)
            return this.setRetainState(false)
         case '/search/document' === currentPath:
            this.$scope.view = 'search'
            if (hasRouteParams && (needle = 'id', !_.keys(this.$routeParams).includes(needle))) {
            // replace() changes the current URL w/out creating a new history record; used for redirecting
               return this.$location.path('/search').replace()
            } else if (this.$scope.docDetail && !this.$scope.docDetail.visible && hasRouteParams) {
               this.$scope.viewState.currentView = "detailsPage"
               this.$scope.docDetail.visible = true
               if (this.isScopeValid() && this.isDocInvalid() && this.hasAvailabilityDocs()) {
                  this.$scope.docDetail.setDocument(this.$scope.docDetail.scope.availabilityDocs[0])
                }
               return this.appState.applyStateFromUrlParams(this.$routeParams)
            }
            break
         case '/search/debug' === currentPath:
            this.$scope.view = ''
            return this.setRetainState(true)
         case '/search/document/debug' === currentPath:
            this.$scope.view = ''
            return this.setRetainState(true)
         case '/diagnostics' === currentPath:
            this.setWindowTitle('Diagnostics')
            this.$scope.view = ''
            return this.setRetainState(false)
         case '/library_card' === currentPath:
            this.setWindowTitle(this.$scope.i18n.translations.LIBRARY_CARD)
            this.$scope.view = 'library_card'
            this.$scope.libraryCardHasRendered = true
            return this.setRetainState(false)
         case '/research_assistant' === currentPath:
            if(this.$scope.isResearchAssistantEnabled) {
               this.setWindowTitle(this.$scope.i18n.translations.RESEARCH_ASSISTANT)
               this.$scope.view = 'search'
               this.$scope.viewState.currentView = 'research_assistant'
               this.$scope.researchAssistantHasRendered = true
               return this.setRetainState(true)
            } else {
               return this.$location.path('/search').replace()
            }
         case '/scope_builder/search' === currentPath:
            this.$scope.view = 'search'
            this.$scope.viewState.currentView = 'search'
            this.$scope.viewState.scopeBuilderMode = true
            if (hasRouteParams && !this.$scope.retainState) { this.appState.applyStateFromUrlParams(this.$routeParams) }
            this.setRetainState(false)
            break
         default:
            this.$location.path('/')
      }
   }

   isScopeValid() {
      return !!this.$scope.docDetail?.scope // The !! (double negation) converts the result into a boolean (true or false), which simplifies the check
   }

   isDocInvalid() {
      return !this.$scope.docDetail?.scope?.doc || !this.$scope.docDetail?.scope?.doc?.id
   }

   hasAvailabilityDocs() {
      return Array.isArray(this.$scope.docDetail?.scope?.availabilityDocs) && 
           this.$scope.docDetail.scope.availabilityDocs.length > 0
   }

   showLibraryCard() {
      this.resetLibraryCardAlerts()
      if (this.$location.path() !== '/library_card') {
         return this.$location.path('/library_card')
      } else {
         return this.$location.path('/')
      }
   }

   switchTab(view: string) {
      return this.$location.path('/' + view)
   }

   resetLibraryCardAlerts() {
      this.alertService.resetAlert('libraryCardError')
      this.alertService.resetAlert('libraryCardListLoadError')
      return this.alertService.resetAlert('libraryCardSuccess')
   }

   isbulkExportAllowed() {
      return this.$scope.feed.items[0]?.recordCount > 0 &&
         this.$scope.allowDownloadSearchResults
   }

   showSearchPagination() {
      return this.$scope.feed &&
         this.$scope.feed.items[0] &&
         this.$scope.feed.items[0].recordCount > 0 &&
         this.$scope.feed.items[0].recordCount > this.config.data.results.pageSize &&
         this.$scope.selectedTab === this.$scope.searchTabs.search
   }
      homePageNavigationEnabled() {
      return this.config.data.homePage?.homePageEnabled

   }
}



ApplicationController.$inject = ['$scope', 'appStateService', 'documentDetailService', '$route',
   '$routeParams', '$location', 'configService', 'utilitiesService', 'metricsService',
   'eventService', 'facetsService', 'flowService', 'advancedSearchService', '$timeout',
   'dialogService', '$q', 'urlRewriter', 'localizationService', '$window', '$broadcastTypes',
   'alertService', 'viewStateService', '$filter', 'menuManagerService', 'translationService', 'citationValues',
   'externalPluginsService', 'journalTitleService', 'savedSearchService', 'savedItemsService', 'cloudStorageService',
   'authenticationService', 'sierraService', 'mediaQueryService', '$authEvents', '$log', '$uibModal', 'searchScopeService', 
   '$document', 'urlService', 'researchAssistantService', 'searchService'
]

angular.module('summonApp.controllers')
   .controller('ApplicationCtrl', ApplicationController)
